module.exports = __webpack_public_path__ + "img/HRProfessionalprogram.fc9bf9bb.png";